<nav class="navbar navbar-white navbar-fixed-top bg-white">
  <div class="d-flex align-items-center">
    <button
      class="navbar-toggler mr-3"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      (click)="collapse()"
      [attr.aria-expanded]="!isCollapsed"
      aria-label="Toggle navigation">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </button>
    <div class="logo-wrapper">
      @if (currentView === '/home') {
        <div class="navbar-brand pull-left">
          {{ 'HOME' | translate }}
        </div>
      }
      @if (getIsLocalUrl && $restaurant.restaurant?.title) {
        <div
          class="navbar-brand pull-left"
          [ngStyle]="{
            'margin-right': loggedIn && getIsLocalUrl ? '0' : '2.8rem',
          }">
          {{ $restaurant.restaurant?.title }}
        </div>
      }
      @if (currentView === '/private/search') {
        <div class="navbar-brand pull-left">
          {{ 'RESTAURANTS' | translate }}
        </div>
      }
      @if (currentView === '/private/orders') {
        <div class="navbar-brand pull-left">
          {{ 'ORDERS' | translate }}
        </div>
      }
      @if (currentView === '/private/profile') {
        <div class="navbar-brand pull-left">
          {{ 'PROFILE' | translate }}
        </div>
      }
      @if (isInvoiceView) {
        <div class="navbar-brand pull-left">
          {{ 'INVOICE' | translate }}
        </div>
      }
    </div>
  </div>
</nav>
